<template>
  <div class="modal withdraw-modal">
    <div class="overlay" @click="$parent.closeWithdrawModal"></div>
    <div class="wrapper">
      <div class="container">
        <div class="form">
          <div class="form-wrapper">
            <img
              class="close"
              @click="$parent.closeWithdrawModal"
              src="./../images/close.svg"
            />
            <div class="form-fields">
              <div class="form-fields-wrapper">
                <!-- Step 1: Amount + Personal Data -->
                <div v-if="step === 1">
                  <div class="title dark">WITHDRAW</div>
                  <div class="fields">
                    <label>
                      <span class="desc">Amount:</span>
                      <input
                        type="text"
                        v-model="amount"
                        @input="allowOnlyNumbers"
                        placeholder="Enter amount"
                      />
                    </label>
                    <label>
                      <span class="desc">Email:</span>
                      <input
                        type="email"
                        v-model="email"
                        placeholder="Your email"
                      />
                    </label>
                    <label>
                      <span class="desc">First name:</span>
                      <input
                        type="text"
                        v-model="name"
                        placeholder="Your first name"
                      />
                    </label>
                    <label>
                      <span class="desc">Last name:</span>
                      <input
                        type="text"
                        v-model="surname"
                        placeholder="Your last name"
                      />
                    </label>
                    <label>
                      <span class="desc">Phone:</span>
                      <input
                        type="text"
                        v-model="phone"
                        placeholder="Your phone number"
                      />
                    </label>
                    <label>
                      <span class="desc">Country:</span>
                      <select v-model="country">
                        <option value="" disabled selected>Your country</option>
                        <option
                          v-for="item in countryOptions"
                          :value="item.id"
                          :key="item.title"
                        >
                          {{ item.title }}
                        </option>
                      </select>
                    </label>
                    <label>
                      <span class="desc">City:</span>
                      <input
                        type="text"
                        v-model="city"
                        placeholder="Your city"
                      />
                    </label>
                    <label>
                      <span class="desc">Address:</span>
                      <input
                        type="text"
                        v-model="address"
                        placeholder="Your address"
                      />
                    </label>
                    <label>
                      <span class="desc">ZIP Code:</span>
                      <input
                        type="text"
                        v-model="postCode"
                        placeholder="Your zip code"
                      />
                    </label>
                  </div>
                  <transition name="fade">
                    <div class="error-desc desc red" v-if="insufficientBalance">
                      Insufficient payout balance. Available: {{ payoutBalanceValue.toFixed(2) }}
                    </div>
                  </transition>
                  <button
                    class="button"
                    :disabled="!step1Valid"
                    @click="goToStep(2)"
                  >
                    NEXT
                  </button>
                  <transition name="fade">
                    <div class="error-desc desc red" v-if="error">
                      {{ error }}
                    </div>
                  </transition>
                </div>

                <!-- Step 2: Choose Payout Method -->
                <div v-if="step === 2">
                  <div class="title dark">CHOOSE PAYOUT METHOD</div>
                  <div class="withdraw-methods">
<!--                    <button class="method-btn sepa-btn" @click="goToStep(3)">-->
<!--                      SEPA-->
<!--                    </button>-->
                    <button class="method-btn visa-btn" @click="submitCard">
                      <img src="./../images/visa.svg" alt="Visa" />
                    </button>
                  </div>
                  <button class="back-btn" @click="goToStep(1)">BACK</button>
                  <transition name="fade">
                    <div class="error-desc desc red" v-if="error">
                      {{ error }}
                    </div>
                  </transition>
                </div>

                <!-- Step 3: SEPA Transfer Details -->
                <div v-if="step === 3">
                  <div class="title dark">SEPA TRANSFER DETAILS</div>
                  <div class="fields">
                    <label>
                      <span class="desc">IBAN:</span>
                      <input
                        type="text"
                        v-model="account_number"
                        placeholder="Your IBAN"
                      />
                    </label>
                    <label>
                      <span class="desc">First name:</span>
                      <input
                        type="text"
                        v-model="first_name"
                        placeholder="First name"
                      />
                    </label>
                    <label>
                      <span class="desc">Last name:</span>
                      <input
                        type="text"
                        v-model="last_name"
                        placeholder="Last name"
                      />
                    </label>
                  </div>
                  <div class="step3-buttons">
                    <button class="back-btn" @click="goToStep(2)">BACK</button>
                    <button
                      class="button"
                      :disabled="!step3Valid || submitting"
                      @click="submitSepa"
                    >
                      SUBMIT
                    </button>
                  </div>
                  <transition name="fade">
                    <div class="error-desc desc red" v-if="error">
                      {{ error }}
                    </div>
                  </transition>
                  <transition name="fade">
                    <div class="success-desc desc green" v-if="success">
                      {{ success }}
                    </div>
                  </transition>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/axios";

export default {
  name: "WithdrawModal",
  props: ["currency"],
  data() {
    return {
      step: 1,
      amount: "",
      email: "",
      name: "",
      surname: "",
      phone: "",
      country: "",
      city: "",
      address: "",
      postCode: "",
      countryOptions: [],
      account_number: "",
      first_name: "",
      last_name: "",
      error: "",
      success: "",
      submitting: false,
    };
  },
  computed: {
    step1Valid() {
      return (
        this.amount &&
        this.email &&
        this.name &&
        this.surname &&
        this.phone &&
        this.country &&
        this.city &&
        this.address &&
        this.postCode &&
        !this.insufficientBalance
      );
    },
    step3Valid() {
      return this.account_number && this.first_name && this.last_name;
    },
    payoutBalanceValue() {
      return Number(this.$parent.profileData?.payout_balance || 0);
    },
    amountValue() {
      return Number(this.amount || 0);
    },
    insufficientBalance() {
      return this.amountValue > 0 && this.amountValue > this.payoutBalanceValue;
    },
  },
  mounted() {
    this.getCountries();
  },
  methods: {
    allowOnlyNumbers() {
      this.amount = this.amount.replace(/[^0-9.,]/g, "");
      const parts = this.amount.split(/[.,]/);
      const integerPart = parts[0];
      let decimalPart = parts[1];
      if (decimalPart !== undefined && decimalPart.length > 2) {
        decimalPart = decimalPart.slice(0, 2);
      }
      this.amount =
        decimalPart !== undefined
          ? `${integerPart}.${decimalPart}`
          : integerPart;
    },
    goToStep(n) {
      if (n === 2 && this.insufficientBalance) {
        this.error = "Insufficient payout balance";
        return;
      }
      this.error = "";
      this.step = n;
      if (n === 3) {
        this.first_name = this.first_name || this.name;
        this.last_name = this.last_name || this.surname;
      }
    },
    extractErrorMessage(err, fallback) {
      const data = err && err.response && err.response.data;
      if (data && data.errors && typeof data.errors === "object") {
        const firstKey = Object.keys(data.errors)[0];
        const firstValue = firstKey ? data.errors[firstKey] : null;
        if (Array.isArray(firstValue) && firstValue[0]) {
          return firstValue[0];
        }
      }
      return (data && data.message) || fallback;
    },
    getCountries() {
      axios
        .get("countries")
        .then((res) => {
          this.countryOptions = res.data.payload;
        })
        .catch((res) => {
          if (res.response && res.response.status === 401) {
            this.$parent.openSignInModal();
          }
        });
    },
    submitCard() {
      this.error = "";
      this.submitting = true;
      axios
        .post("user/withdraw-requests", { amount: this.amount })
        .then((res) => {
          const withdrawId = res.data.id || (res.data.payload && res.data.payload.id) || (res.data.data && res.data.data.id);
          return axios.post(
            "user/withdraw-requests/" + withdrawId + "/payout/card-form",
            {
              email: this.email,
              name: this.name,
              surname: this.surname,
              phone: this.phone,
              country: this.country,
              currency: this.$parent.currencyCode,
              city: this.city,
              address: this.address,
              postCode: this.postCode,
            }
          );
        })
        .then((res) => {
          const redirectUrl = res.data.redirect_url || (res.data.payload && res.data.payload.redirect_url);
          if (redirectUrl) {
            window.location = redirectUrl;
          }
        })
        .catch((err) => {
          this.error = this.extractErrorMessage(
            err,
            "Network error. Please try again."
          );
        })
        .finally(() => {
          this.submitting = false;
        });
    },
    submitSepa() {
      if (!this.step3Valid || this.submitting) return;
      this.error = "";
      this.success = "";
      this.submitting = true;
      axios
        .post("user/withdraw-requests", { amount: this.amount })
        .then((res) => {
          const withdrawId = res.data.id || (res.data.payload && res.data.payload.id) || (res.data.data && res.data.data.id);
          return axios.post(
            "user/withdraw-requests/" + withdrawId + "/payout/sepa-manual",
            {
              account_number: this.account_number,
              first_name: this.first_name,
              last_name: this.last_name,
            }
          );
        })
        .then(() => {
          this.success = "Withdrawal request submitted successfully!";
          setTimeout(() => {
            this.$parent.closeWithdrawModal();
          }, 1500);
        })
        .catch((err) => {
          this.error = this.extractErrorMessage(
            err,
            "Network error. Please try again."
          );
        })
        .finally(() => {
          this.submitting = false;
        });
    },
  },
};
</script>

<style scoped lang="scss">
.withdraw-modal {
  .close {
    filter: brightness(0) invert(1);
  }

  .wrapper {
    max-width: 685px;
    max-height: 100%;
    overflow: auto;
  }

  .container {
    padding: 34px 36px;
  }

  .form-fields-wrapper {
    max-width: 600px;
    margin: 0 auto;
    padding-bottom: 12px;
  }

  .title {
    text-align: center;
  }

  .fields {
    margin-top: 20px;
    display: flex;
    gap: 10px 30px;
    flex-wrap: wrap;
  }

  .fields label {
    display: inline-block;
    width: calc(50% - 20px);
  }

  .fields label input,
  .fields label select {
    margin-top: 8px;
  }

  .fields label .desc {
    font-weight: 600;
  }

  .fields label select {
    appearance: none;
    -webkit-appearance: none;
    cursor: pointer;
  }

  .withdraw-methods {
    display: flex;
    justify-content: center;
    gap: 20px;
    margin-top: 40px;
  }

  .method-btn {
    width: 200px;
    height: 56px;
    border-radius: 8px;
    background: #120f0f;
    border: 1px solid #433a3a;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    text-transform: uppercase;
  }

  .method-btn img {
    height: 24px;
  }

  .back-btn {
    display: block;
    margin: 24px auto 0;
    background: transparent;
    border: 1px solid rgba(255, 255, 255, 0.35);
    border-radius: 8px;
    color: #fff;
    padding: 12px 28px;
    text-transform: uppercase;
  }

  .step3-buttons {
    display: flex;
    justify-content: center;
    gap: 16px;
    margin-top: 24px;
  }

  .step3-buttons .back-btn {
    margin: 0;
  }

  .step3-buttons .button {
    margin: 0 !important;
    display: inline-flex !important;
    align-items: center;
    justify-content: center;
  }

  .form-fields-wrapper > div > .button {
    margin: 24px auto 0;
    max-width: 276px;
  }

  .error-desc,
  .success-desc {
    text-align: center;
    margin-top: 12px;
  }
}

@media screen and (max-width: 768px) {
  .withdraw-modal .wrapper {
    max-width: 100%;
  }

  .withdraw-modal .container {
    padding: 24px 16px;
  }

  .withdraw-modal .fields label {
    width: 100%;
  }

  .withdraw-modal .withdraw-methods {
    flex-direction: column;
    align-items: center;
    gap: 12px;
  }

  .withdraw-modal .method-btn {
    width: 100%;
    max-width: 280px;
  }

  .withdraw-modal .step3-buttons {
    flex-direction: column;
    align-items: center;
  }

  .withdraw-modal .step3-buttons .back-btn,
  .withdraw-modal .step3-buttons .button {
    width: 100%;
    max-width: 276px;
  }
}
</style>

